// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  vision: {
    autoRefraction: {
      OD: {
        sph: null,
        cyl: null,
        axis: null
      },
      OS: {
        sph: null,
        cyl: null,
        axis: null
      }
    },
    refraction: {
      OD: {
        sph: null,
        cyl: null,
        axis: null,
        ipd: null
      },
      OS: {
        sph: null,
        cyl: null,
        axis: null,
        ipd: null
      }
    },
    subjectiveRefraction: {
      OD: {
        sph: null,
        cyl: null,
        axis: null,
        dva: null,
        add: null,
        nva: null,
        ipd: null
      },
      OS: {
        sph: null,
        cyl: null,
        axis: null,
        dva: null,
        add: null,
        nva: null,
        ipd: null
      }
    },
    unAided: {
      Distance: {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      },
      Near: {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      }
    },
    aided: {
      Distance: {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      },
      Near: {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      }
    },
    fieldOfVision: {
      "Horizontal Plane": {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      },
      "Vertial Plane": {
        rEye: null,
        lEye: null,
        both: null,
        results: ""
      }
    },
    colorVision: {
      Ishiara: {
        eye: "",
        results: ""
      },
      "Lantern/Others": {
        eye: "",
        results: ""
      }
    },
    bestCorrectiveVisualAcuity: {
      Distance: {
        rEye: null,
        lEye: null,
        both: null
      },
      Near: {
        rEye: null,
        lEye: null,
        both: null
      }
    },
    pinHole: {
      Distance: {
        rEye: null,
        lEye: null,
        both: null
      },
      Near: {
        rEye: null,
        lEye: null,
        both: null
      }
    }
  },
  anteriorSegment: {
    Lids: {
      rEye: null,
      lEye: null
    },
    Conjunctiva: {
      rEye: null,
      lEye: null
    },
    Cornea: {
      rEye: null,
      lEye: null
    },
    "A/C": {
      rEye: null,
      lEye: null
    },
    "Pupil/Iris": {
      rEye: null,
      lEye: null
    },
    Lens: {
      rEye: null,
      lEye: null
    }
  },
  posteriorSegment: {
    Vitreous: {
      rEye: null,
      lEye: null
    },
    Fundus: {
      rEye: null,
      lEye: null
    }
  },
  glassPrescription: {
    OD: {
      sph: null,
      cyl: null,
      axis: null,
      pd: null,
      add: null,
      prism: null
    },
    OS: {
      sph: null,
      cyl: null,
      axis: null,
      pd: null,
      add: null,
      prism: null
    }
  },
  lensPrescription: {
    OD: {
      sph: null,
      cyl: null,
      axis: null,
      add: null
    },
    OS: {
      sph: null,
      cyl: null,
      axis: null,
      add: null
    }
  },
  remarks: {
    glassPrescription: "",
    lensPrescription: ""
  }
};
